import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Connections from "@/pages/Connections";
import TableBrowser from "@/pages/TableBrowser";
import Pipelines from "@/pages/Pipelines";
import PipelineBuilder from "@/pages/PipelineBuilder";
import Schedules from "@/pages/Schedules";
import History from "@/pages/History";
import CDC from "@/pages/CDC";
import Tenants from "@/pages/Tenants";
import RLS from "@/pages/RLS";
import DataPreview from "@/pages/DataPreview";
import Documentation from "@/pages/Documentation";
import AIAgent from "@/pages/AIAgent";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="tenants" element={<Tenants />} />
            <Route path="connections" element={<Connections />} />
            <Route path="tables" element={<TableBrowser />} />
            <Route path="pipelines" element={<Pipelines />} />
            <Route path="pipelines/new" element={<PipelineBuilder />} />
            <Route path="pipelines/:id/edit" element={<PipelineBuilder />} />
            <Route path="schedules" element={<Schedules />} />
            <Route path="history" element={<History />} />
            <Route path="cdc" element={<CDC />} />
            <Route path="rls" element={<RLS />} />
            <Route path="preview" element={<DataPreview />} />
            <Route path="ai-agent" element={<AIAgent />} />
            <Route path="docs" element={<Documentation />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
